<template>
    <div>
        <card-header title="Leads Database" icon="fa-address-card"/>

        <card-body>
            <card-list>
                <search-list-item @action="searchLeads"/>
                <subheader-list-item title="Recent Leads" icon="fas fa-history" :badge="leads.length"/>
                <lead-list-item
                    :card="card"
                    :lead="l"
                    v-for="l in leads"
                    :key="l.id"
                    :active="child && child.definition.component === 'lead' && child.props.leadId === l.id.toString()"
                    @click="$openCard('lead', {leadId: l.id}, card);"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardList from "../../TIER/components/CardList";
    import CardBody from "@/TIER/components/CardBody";
    import SearchListItem from "../../TIER/components/SearchListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import LeadListItem from "@/components/LeadListItem";
    import {client as http} from "@/http_client";

    export default {
        name: "Leads",
        props: ['card', 'child'],
        components: {LeadListItem, SubheaderListItem, CardBody, SearchListItem, CardList, CardHeader},
        data: function() {
            return {
                leads: []
            };
        },
        methods: {
            loadLeads(force) {
                this.$emit('loading', true);
                http.get('/api/leads', {force}).then(response => {
                    this.leads = response.data;
                    this.$emit('loading', false);
                });
            },
            searchLeads: function(q) {
                this.$openCard('search-leads', {query: q}, this.card);
            },
            reload: function() {
                this.loadLeads(true);
            }
        },
        mounted() {
            this.loadLeads();
        }
    };
</script>

<style lang="scss" scoped>

</style>
